import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, font, fontSize, fontWeight, lineHeight, media, space } from "../tokens.stylex.ts";
export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Leading visual, e.g. an app icon. */
  leading?: ReactNode;
  /** Breadcrumb or eyebrow above the title. */
  eyebrow?: ReactNode;
  actions?: ReactNode;
}
export function PageHeader({
  title,
  description,
  leading,
  eyebrow,
  actions
}: PageHeaderProps) {
  return <header className="x78zum5 x1cy8zhl x1qughib x4l6xbm x1a02dak x1uwj2lv x1o97avp">
      <div className="x78zum5 x6s0dn4 xpcbtbh xeuugli">
        {leading}
        <div className="x78zum5 xdt5ytf xjenv9e xeuugli">
          {eyebrow ? <div className="xxg9qwl xmccgnw xjat59b xxe3v3u">{eyebrow}</div> : null}
          <h1 className="x1ghz6dp x6cdl7o x1ivwu1z x1lg07ej xfpseah x9aqtqa">{title}</h1>
          {description ? <div className="x1ghz6dp xluwven x187ovcu x9tub0y x11gisft">{description}</div> : null}
        </div>
      </div>
      {actions ? <div className="x78zum5 x18pmjb x1mt1orb x1rnidkh x6s0dn4 x1a62zme x2lah0s x1dcy9r8">{actions}</div> : null}
    </header>;
}